import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
} from "@chakra-ui/react";
import fetchWithToken from "views/auth/signIn/axiosInstance";
import { useTranslation } from "react-i18next";

function CreateHoliday() {
  const { t } = useTranslation();
  const [date, setDate] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [error, setError] = useState(null);
  const pageId = 24; // Page ID for holiday creation
  // Validate the form and return a specific error message, if any.
  const validateForm = () => {
    if (!date) return t("Date is required");
    if (!countryCode) return t("Country code is required");
    if (!name.trim()) return t("Holiday name is required");
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const errorMsg = validateForm();
    if (errorMsg) {
      setError(errorMsg);
      return;
    }

    try {
      const data = {
        date,
        country_code: countryCode.toUpperCase(),
        name,
        is_active: isActive,
      };
      const response = await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/holidays?page_id=${pageId}`,
        "POST",
        data
      );
      if (response?.status === "success") {
        window.location.reload();
      } else {
        setError(response?.message || t("Failed to create holiday"));
      }
    } catch (error) {
      setError(t("Failed to create holiday. Please try again later."));
    }
  };

  return (
    <FormControl>
      <form onSubmit={handleSubmit}>
        <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
          {t("Date")}
        </FormLabel>
        <Input
          isRequired
          type="date"
          mb="24px"
          size="lg"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
          {t("Country Code")}
        </FormLabel>
        <Select
          isRequired
          placeholder={t("Select Country")}
          mb="24px"
          size="lg"
          value={countryCode}
          onChange={(e) => setCountryCode(e.target.value)}
        >
          <option value="IT">Italy</option>
          {/* Add more country codes as needed */}
        </Select>
        <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
          {t("Holiday Name")}
        </FormLabel>
        <Input
          isRequired
          type="text"
          placeholder={t("Holiday Name")}
          mb="24px"
          size="lg"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
          {t("Active")}
        </FormLabel>
        <Switch
          isChecked={isActive}
          onChange={(e) => setIsActive(e.target.checked)}
          mb="24px"
          colorScheme="cyan"
        />
        <Button
          type="submit"
          fontSize="sm"
          colorScheme="cyan"
          fontWeight="500"
          w="100%"
          h="50px"
          mb="24px"
          color="white"
        >
          {t("Create Holiday")}
        </Button>
        {error && (
          <Box color="red" mt={2}>
            {Array.isArray(error)
              ? error.map((line, i) => <div key={i}>{line}</div>)
              : <div>{error}</div>
            }
          </Box>
        )}
      </form>
    </FormControl>
  );
}

export default CreateHoliday;